import React, { Fragment } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';

// Components
import { Mui } from 'components';

import { Confirmation } from '../Dialogs';

const useStyles = Mui.makeStyles(theme => ({
  root: { borderColor: theme.palette.primary.main },
  list: { padding: 0 },
  icon: { backgroundColor: theme.palette.primary.main },
  iconWarning: { backgroundColor: theme.palette.warning.main },
  iconError: { backgroundColor: theme.palette.error.main },
  selectedRow: {
    backgroundColor: theme.palette.primary.main,
    '& .MuiAvatar-root': { backgroundColor: 'white', color: theme.palette.primary.main },
    '&:hover .MuiAvatar-root': { backgroundColor: theme.palette.primary.main, color: 'white' },
    '& .MuiListItemText-root span, & .MuiListItemText-root p': { color: 'white' },
    '&:hover .MuiListItemText-root span, &:hover .MuiListItemText-root p': {
      color: theme.palette.secondary.main,
    },
  },
  selectedRowWarning: {
    backgroundColor: theme.palette.warning.main,
    '& .MuiAvatar-root': { backgroundColor: 'white', color: theme.palette.warning.main },
    '&:hover .MuiAvatar-root': { backgroundColor: theme.palette.warning.main, color: 'white' },
    '& .MuiListItemText-root span, & .MuiListItemText-root p': { color: 'white' },
    '&:hover .MuiListItemText-root span, &:hover .MuiListItemText-root p': {
      color: theme.palette.common.white,
    },
  },
  selectedRowError: {
    backgroundColor: theme.palette.error.main,
    '& .MuiAvatar-root': { backgroundColor: 'white', color: theme.palette.error.main },
    '&:hover .MuiAvatar-root': { backgroundColor: theme.palette.error.main, color: 'white' },
    '& .MuiListItemText-root span, & .MuiListItemText-root p': { color: 'white' },
    '&:hover .MuiListItemText-root span, &:hover .MuiListItemText-root p': {
      color: theme.palette.common.white,
    },
  },
}));

function getListItemClassName(action, classes) {
  if (!action.selected) return '';

  if (action.color === 'error') return classes.selectedRowError;
  if (action.color === 'warning') return classes.selectedRowWarning;
  return classes.selectedRow;
}

function List({ actions, children, disablePaper, loading, subheader, open, setOpen }) {
  // Hooks
  const classes = useStyles();

  const list = (
    <Mui.List className={classes.list}>
      {!!subheader && <Mui.ListSubheader disableSticky>{subheader}</Mui.ListSubheader>}
      {actions.map(action => (
        <Fragment key={action.key}>
          <Mui.ListItem
            button
            disabled={action.disabled}
            className={getListItemClassName(action, classes)}
            onClick={() => (action.onClick ? action.onClick() : setOpen(action.key))}>
            <Mui.ListItemAvatar>
              <Mui.Avatar
                className={clsx(
                  action.color === 'error' && classes.iconError,
                  action.color === 'warning' && classes.iconWarning,
                  !action.color && classes.icon,
                )}>
                <Mui.Icon>{action.icon}</Mui.Icon>
              </Mui.Avatar>
            </Mui.ListItemAvatar>
            <Mui.ListItemText primary={action.label} secondary={action.instructions} />
          </Mui.ListItem>
          <Confirmation
            title={action.label}
            open={open === action.key}
            loading={loading}
            onClose={() => setOpen('')}
            onConfirm={action.submit}>
            {action.confirm}
            {children}
          </Confirmation>
        </Fragment>
      ))}
    </Mui.List>
  );

  if (disablePaper) return list;

  return (
    <Mui.Paper variant="outlined" className={classes.root}>
      {list}
    </Mui.Paper>
  );
}

List.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.any,
  disablePaper: PropTypes.bool,
  loading: PropTypes.bool,
  subheader: PropTypes.string,
  open: PropTypes.string,
  setOpen: PropTypes.func,
};

export default List;
